import { getBusinessActivityAdditionalActivityMap } from '../../localeConstants';
export var estateAgentBusinessActivityCodeList = ['SV-003', 'SV-004', 'SV-013', 'SV-014', 'SV-015', 'SV-016', 'SV-017', 'SV-018', 'BCS-073', 'BCS-221', 'BCS-222'];
export var getEstateAgentBusinessActivityDefaultAddtionalActivityList = function getEstateAgentBusinessActivityDefaultAddtionalActivityList(businessActivity) {
  var list = [];

  if (['BCS-221', 'BCS-073', 'SV-003', 'SV-004'].includes(businessActivity)) {
    list.push(getBusinessActivityAdditionalActivityMap().propertyEstateManagementNonRics.value);
  }

  if (['BCS-222'].includes(businessActivity)) {
    list.push(getBusinessActivityAdditionalActivityMap().propertySearchAgency.value);
  }

  if (['SV-003', 'SV-004'].includes(businessActivity)) {
    list.push(getBusinessActivityAdditionalActivityMap().estateAgentAndOrLettingAgent.value);
  }

  if (['SV-013', 'SV-014'].includes(businessActivity)) {
    list.push(getBusinessActivityAdditionalActivityMap().propertySourcing.value);
  }

  if (['SV-014', 'SV-015'].includes(businessActivity)) {
    list.push(getBusinessActivityAdditionalActivityMap().residentialPropertyOperatorRentToRent.value);
  }

  return list;
};